(function () {
  function initCollectionHeroCopy() {
    var heroText = document.querySelector('.hero-text-text_WWGUqP, .collection [class*="hero-text-text_"], .collection .ss_hero_24_HpPnEM [class*="text_"], .collection .ss-hero-24 [class*="text_"]');
    var heroRoot = document.querySelector('.ss_hero_24_HpPnEM, .ss-hero-24');
    if (heroRoot) {
      heroRoot.style.marginBottom = '0';
    }
    if (!heroText) return;

    var existingToggle = heroText.parentElement && heroText.parentElement.querySelector('.tcle-hero-intro-toggle');
    var isExpanded = heroText.dataset.tcleHeroExpanded === 'true';

    if (!heroText.id) {
      heroText.id = 'tcle-hero-intro-' + Math.random().toString(36).slice(2, 10);
    }

    if (!isExpanded) {
      heroText.classList.add('tcle-hero-intro--collapsed');
    }

    var lineHeight = parseFloat(window.getComputedStyle(heroText).lineHeight || '24');
    var expandedHeight = heroText.scrollHeight;
    var clampHeight = lineHeight * 3 + 6;

    if (expandedHeight <= clampHeight + 8) {
      heroText.classList.remove('tcle-hero-intro--collapsed');
      heroText.dataset.tcleHeroReady = 'true';
      if (existingToggle) existingToggle.remove();
      return;
    }

    var heroTextColorSource = heroText.querySelector('p, span, div') || heroText;
    var heroTextColor = window.getComputedStyle(heroTextColorSource).color;

    if (existingToggle) {
      existingToggle.style.color = heroTextColor;
      existingToggle.setAttribute('aria-controls', heroText.id);
      existingToggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      existingToggle.textContent = isExpanded ? 'Show less' : 'Read more';
      heroText.dataset.tcleHeroReady = 'true';
      return;
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'tcle-hero-intro-toggle';
    button.setAttribute('aria-controls', heroText.id);
    button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    button.style.color = heroTextColor;
    button.textContent = isExpanded ? 'Show less' : 'Read more';
    button.addEventListener('click', function () {
      var expanded = button.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        heroText.dataset.tcleHeroExpanded = 'false';
        heroText.classList.add('tcle-hero-intro--collapsed');
        button.setAttribute('aria-expanded', 'false');
        button.textContent = 'Read more';
      } else {
        heroText.dataset.tcleHeroExpanded = 'true';
        heroText.classList.remove('tcle-hero-intro--collapsed');
        button.setAttribute('aria-expanded', 'true');
        button.textContent = 'Show less';
      }
    });
    heroText.insertAdjacentElement('afterend', button);
    heroText.dataset.tcleHeroReady = 'true';
  }

  function getDesktopSidebarFacets(scope) {
    return Array.prototype.slice
      .call((scope || document).querySelectorAll('.facets-vertical details.js-filter'))
      .filter(function (facet) {
        return !facet.closest('menu-drawer, .mobile-facets__wrapper, .mobile-facets__details');
      });
  }

  function syncFacetA11y(facet) {
    var summary = facet.querySelector(':scope > summary, :scope > .facets__summary, summary, .facets__summary');
    if (summary) {
      summary.setAttribute('aria-expanded', facet.hasAttribute('open') ? 'true' : 'false');
    }
  }

  function collapseDesktopCollectionFilters(scope) {
    getDesktopSidebarFacets(scope).forEach(function (facet) {
      facet.removeAttribute('open');
      syncFacetA11y(facet);
    });
  }

  function initCustomSort() {
    var roots = document.querySelectorAll('[data-tcle-sort]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (root.dataset.tcleSortReady === 'true') continue;

      var trigger = root.querySelector('[data-tcle-sort-trigger]');
      var list = root.querySelector('[data-tcle-sort-list]');
      var label = root.querySelector('[data-tcle-sort-label]');
      var hidden = root.closest('.mobile-facets__sort').querySelector('#SortBy-mobile-hidden');
      if (!trigger || !list) continue;

      (function(trigger, list, label, hidden, root) {
        trigger.addEventListener('click', function(e) {
          e.stopPropagation();
          e.preventDefault();
          var open = list.hasAttribute('data-open');
          if (open) {
            list.removeAttribute('data-open');
            trigger.setAttribute('aria-expanded', 'false');
          } else {
            list.setAttribute('data-open', '');
            trigger.setAttribute('aria-expanded', 'true');
          }
        });

        var options = list.querySelectorAll('[data-value]');
        for (var j = 0; j < options.length; j++) {
          (function(option) {
            function select() {
              for (var k = 0; k < options.length; k++) {
                options[k].classList.remove('tcle-sort-custom__option--selected');
                options[k].setAttribute('aria-selected', 'false');
              }
              option.classList.add('tcle-sort-custom__option--selected');
              option.setAttribute('aria-selected', 'true');
              label.textContent = option.textContent.trim();
              hidden.value = option.getAttribute('data-value');
              list.removeAttribute('data-open');
              trigger.setAttribute('aria-expanded', 'false');
            }
            option.addEventListener('click', function(e) { e.stopPropagation(); select(); });
            option.addEventListener('keydown', function(e) {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                select();
              }
            });
          })(options[j]);
        }

        document.addEventListener('click', function(e) {
          if (!root.contains(e.target)) {
            list.removeAttribute('data-open');
            trigger.setAttribute('aria-expanded', 'false');
          }
        });
      })(trigger, list, label, hidden, root);

      root.dataset.tcleSortReady = 'true';
    }
  }

  function run(scope) {
    collapseDesktopCollectionFilters(scope || document);
    initCollectionHeroCopy();
    initCustomSort();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run(document);
    });
  } else {
    run(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    run(event.target || document);
  });

  document.addEventListener('facets:updated', function () {
    run(document);
  });

  var container = document.getElementById('main-collection-filters');
  if (container) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          run(document);
          break;
        }
      }
    });

    observer.observe(container, { childList: true, subtree: true });
  }
})();
